export default "__VITE_ASSET__ec458756__"